import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  FormControlLabel,
  FormGroup,
  Button,
  TextField,
  Checkbox,
  Grid,
  MenuItem,
} from "@mui/material";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { findIndexDefaultValue, getPropertieObjectById } from "../helper";

export default class CheckboxList {
  static DisplayTab(props) {
    const { onChange, onCheckChange, onPropertieChange, state, error } = props;
    const toolTip = getUnitPropertie(state, "toolTip");
    const required = getUnitPropertie(state, "required");
    const readOnly = getUnitPropertie(state, "readOnly");
    const hidden = getUnitPropertie(state, "hidden");
    const isRequired = getUnitPropertie(state, "isRequired");
    const label = getUnitPropertie(state, "label");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.descricao}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label={language.propertieToolTip}
            value={toolTip || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipToolTip}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  onChange={(event) => onCheckChange(event)}
                  value={hidden}
                  checked={hidden || false}
                />
              }
              label={language.propertieHidden}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      addRowDefaultValue,
      state,

      handleDefaultValueChange,
      handleDefaultValueType,
      deleteDefaultValueRow,
      onPropertieChange,
      handlePropertieChangeDataList,
      dataList,
    } = props;

    const index = findIndexDefaultValue(state, "options");
    const variableName = getUnitPropertie(state, "variableName");
    const jsonFieldValue = getUnitPropertie(state, "jsonFieldValue");
    const jsonFieldText = getUnitPropertie(state, "jsonFieldText");

    const dataListValue = getUnitPropertie(state, "dataList");
    const dataListColumn = getUnitPropertie(state, "dataListColumn");

    const dataListContent = dataList?.content || [];
    const selectedDataList = dataListContent.find(
      (d) => d.id === dataListValue?.id,
    );
    const dataListColumnsList =
      selectedDataList?.columns?.map((c) => c.name) || [];

    const defaultobj = state.properties[index] ? state.properties[index] : "";

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            select
            onChange={(event) => handleDefaultValueType(event)}
            name="options"
            variant="outlined"
            id="options"
            label={language.datasourceType}
            value={defaultobj && defaultobj.type}
            fullWidth
          >
            <MenuItem value="options">{language.values}</MenuItem>
            <MenuItem value="api">{language.api}</MenuItem>
            <MenuItem value="dataList">{language.DataList}</MenuItem>
            <MenuItem value="variable">{language.processVariable}</MenuItem>
          </TextField>
        </Grid>
        {defaultobj && defaultobj.type === "options" && (
          <React.Fragment>
            <Grid item size={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => addRowDefaultValue("options")}
                startIcon={<AddIcon />}
              >
                {language.addNew}
              </Button>
            </Grid>
            <Grid item size={12}>
              <table id="table" class="table table-hover">
                <thead>
                  <tr>
                    <th>{language.itemkey}</th>
                    <th>{language.value}</th>
                    <th>{language.text}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {defaultobj &&
                    defaultobj.value &&
                    defaultobj.value.map((item, index) => {
                      return (
                        <tr>
                          <td>
                            <input
                              name="key"
                              value={defaultobj.value[index].key || ""}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  event,
                                  index,
                                  "options",
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              name="value"
                              value={defaultobj.value[index].value || ""}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  event,
                                  index,
                                  "options",
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              name="text"
                              value={defaultobj.value[index].text || ""}
                              onChange={(event) =>
                                handleDefaultValueChange(
                                  event,
                                  index,
                                  "options",
                                )
                              }
                            />
                          </td>
                          <td>
                            <DeleteIcon
                              onClick={() =>
                                deleteDefaultValueRow(index, "options")
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Grid>
          </React.Fragment>
        )}

        {defaultobj && defaultobj.type === "api" && (
          <React.Fragment>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) =>
                  handleDefaultValueChange(event, 0, "options")
                }
                name="api"
                variant="outlined"
                id="api"
                label="URL"
                value={defaultobj.value}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldValue"
                variant="outlined"
                id="jsonFieldValue"
                label={language.jsonFieldValue}
                value={jsonFieldValue || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldText"
                variant="outlined"
                id="jsonFieldText"
                label={language.jsonFieldText}
                value={jsonFieldText || ""}
              />
            </Grid>
          </React.Fragment>
        )}

        {defaultobj && defaultobj.type === "variable" && (
          <React.Fragment>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="variableName"
                variant="outlined"
                id="variableName"
                label={language.variableName}
                value={variableName || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldValue"
                variant="outlined"
                id="jsonFieldValue"
                label={language.jsonFieldValue}
                value={jsonFieldValue || ""}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                onChange={(event) => onPropertieChange(event)}
                name="jsonFieldText"
                variant="outlined"
                id="jsonFieldText"
                label={language.jsonFieldText}
                value={jsonFieldText || ""}
              />
            </Grid>
          </React.Fragment>
        )}

        {defaultobj && defaultobj.type === "dataList" && (
          <React.Fragment>
            <Grid item size={12}>
              <TextField
                fullWidth
                select
                labelId="datalist-type-label"
                id="datalist-type-select"
                name="dataList"
                value={dataListValue}
                onChange={(event) => handlePropertieChangeDataList(event)}
                label={language.chooseAList}
                renderValue={(selected) => (selected ? selected.name : "")}
              >
                {dataListContent.map((dataValue) => {
                  return (
                    <MenuItem key={dataValue.id} value={dataValue}>
                      {dataValue.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>

            <Grid item size={12}>
              <TextField
                select
                fullWidth
                labelId="datalist-column-type-label"
                id="datalist-column-type-select"
                name="dataListColumn"
                value={dataListColumn}
                onChange={(event) => onPropertieChange(event)}
                label={language.chooseAColumnFromTheList}
                renderValue={(selected) => selected || ""}
              >
                {dataListColumnsList.map((dataColumn, index) => {
                  return (
                    <MenuItem key={`${index}_${dataColumn}`} value={dataColumn}>
                      {dataColumn}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
